import React from 'react'

export const PagePropsContext = React.createContext({
  categories: [],
  categoryStories: [],
  latestStories: [],
  tags: []
});
